import { sparkToast } from '@spark';

export const REQUIRED_FIELDS_ERROR = 'Please fill in all required fields.';

/** Footer copy plus a Spark error toast when Next is blocked by empty required fields. */
export const reportRequiredFieldsError = () => {
    sparkToast.error(REQUIRED_FIELDS_ERROR);
    return REQUIRED_FIELDS_ERROR;
};
